class CCNewsletterPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-cc-newsletter-dialog]');
    this.closeButtons = this.querySelectorAll('[data-cc-newsletter-close]');
    this.storageKey = `cc-newsletter-popup-${this.dataset.campaign || 'welcome'}`;
    this.delay = Math.max(0, Number(this.dataset.delay || 7)) * 1000;

    if (!this.dialog || this.wasDismissed() || window.CCReferralVisit?.active) return;

    this.openTimer = window.setTimeout(() => this.open(), this.delay);
    this.closeButtons.forEach((button) => button.addEventListener('click', () => this.close()));
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
    });
  }

  wasDismissed() {
    try {
      return Number(window.localStorage.getItem(this.storageKey) || 0) > Date.now();
    } catch (error) {
      return false;
    }
  }

  rememberDismissal() {
    const days = Math.max(1, Number(this.dataset.hideDays || 14));
    try {
      window.localStorage.setItem(this.storageKey, String(Date.now() + days * 86400000));
    } catch (error) {
      // The popup remains functional when storage is unavailable.
    }
  }

  open() {
    if (window.CCReferralVisit?.active) return;
    if (document.querySelector('[data-cc-referral-dialog][open], #smile-ui-container .smile-panel-frame-container, #smile-ui-container .smile-prompt-frame-container')) {
      this.openTimer = window.setTimeout(() => this.open(), 3000);
      return;
    }
    this.hidden = false;
    document.documentElement.classList.add('cc-newsletter-open');
    const email = this.querySelector('input[type="email"]');
    if (email) email.focus({ preventScroll: true });
  }

  close() {
    window.clearTimeout(this.openTimer);
    this.rememberDismissal();
    this.hidden = true;
    document.documentElement.classList.remove('cc-newsletter-open');
  }
}

if (!customElements.get('cc-newsletter-popup')) {
  customElements.define('cc-newsletter-popup', CCNewsletterPopup);
}
